const PUOND_CONVERT = 0.00220462;

module.exports = {
    PUOND_CONVERT,
}